import { Link, Stack, TextField, Typography } from '@mui/material';
import { routes } from '@routes';
import { FunctionComponent, useRef } from 'react';
import { NavLink } from 'react-router-dom';

import { useAuth } from '@context/auth';
import { LoadingButton } from '@mui/lab';

export const ForgotPasswordForm: FunctionComponent = () => {
  const emailRef = useRef<HTMLInputElement | null>(null);
  const {
    errors,
    forgotPassword: { isLoading, mutate: loginMutation },
  } = useAuth();

  const handleClick = () => {
    loginMutation({
      forgotPasswordDto: {
        email: emailRef.current?.value ?? '',
      },
    });
  };
  const emailError = errors?.find(({ field }) => field === 'email');

  return (
    <Stack spacing={2.5}>
      <TextField
        error={Boolean(emailError)}
        inputRef={emailRef}
        name="email"
        label="Email address"
        helperText={emailError?.message}
      />
      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        onClick={handleClick}
        loading={isLoading}
      >
        Continue
      </LoadingButton>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        sx={{ py: 1.5 }}
        spacing={1.5}
      >
        <div>
          <Typography variant="button" textTransform="none" fontWeight="400">
            Already have an account?.{' '}
          </Typography>
          <Link
            component={NavLink}
            variant="subtitle2"
            underline="hover"
            to={routes.login}
          >
            Login
          </Link>
        </div>
      </Stack>
    </Stack>
  );
};
